import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../../styles/styles';


import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBIcon, MDBModalFooter } from 'mdbreact';


const RenderEmail = ({ classes, input, ...props }) => {
  const { meta, registrationForm } = props;
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      aria-describedby="name-error-text"
      error={conditionError}
      style={{width:'100%'}}
    >
      <MDBInput
        {...input}
        name="Email"
        type="Email"
        label="Email"
        disableUnderline
        error={conditionError}
      />
      {conditionError && (
        <FormHelperText id="name-error-text" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(RenderEmail);
